import Box from "@mui/material/Box";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";


export const UserInfoBox = styled(Box)(({ theme }) => ({
    position: "relative",
    margin: theme.spacing(0, 2),
     textAlign: "center",
  
    // borderRadius: theme.shape.borderRadius,
    // backgroundColor: alpha(theme.palette.common.white, 0.15),
    // "&:hover": {
    //   backgroundColor: alpha(theme.palette.common.white, 0.25),
    // },
    // marginRight: theme.spacing(2),
    // marginLeft: 0,
    // width: "100%",
    // [theme.breakpoints.up("sm")]: {
    //   marginLeft: theme.spacing(3),
    //   width: "auto",
    // },
  }));
  
  export const UserCardInfoHeader = styled(Box)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: "700",
  }));
  
  export const UserCardInfoText = styled(Box)(({ theme }) => ({
    color: theme.palette.text.primary,
  }));
  